"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const CsvExports_1 = __importDefault(require("./CsvExports"));
const StartedAndCompletedByAttribute_1 = __importDefault(require("./StartedAndCompletedByAttribute"));
// TODO Support more graphs: maybe instead of having all possible attribute
// graph, have a dropdown to select the attribute? and add the graph to the
// page? And add it to a user's preferences?
const StartedAndCompletedByStrate = () => (react_1.default.createElement(StartedAndCompletedByAttribute_1.default, { attributeName: "strate", direction: "vertical" }));
exports.default = [CsvExports_1.default, StartedAndCompletedByStrate];
